import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const MediaEntertainment = () => {
  return (
    <>
      <SEO 
        title="Media & Entertainment Solutions - Abacies Logiciels"
        description="Transform media operations with content management systems, streaming platforms, audience analytics, and AI-powered content recommendation engines for media and entertainment companies."
        keywords="media technology, entertainment software, content management systems, streaming platforms, media analytics, entertainment solutions"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Media & Entertainment
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Media & Entertainment page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Media & Entertainment. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default MediaEntertainment;
